export const allTypes = [
  {
    key: "keypoints",
    value: "핵심정리",
  },
  {
    key: "reading",
    value: "지문읽기",
  },
  {
    key: "words",
    value: "단어학습",
  },
  {
    key: "syntax_analysis",
    value: "구문분석",
    levels: [
      {
        key: "elementary",
        value: "하",
        text: "주어, 동사, 목적어, 보어(SVOC)를 구분하는 문제입니다. 각 문장성분의 범위는 주어집니다.",
      },
      {
        key: "intermediate",
        value: "중",
        text: "주어, 동사, 목적어, 보어(SVOC)를 구분하는 문제입니다. 각 문장성분의 범위는 직접 지정해야 합니다.",
      },
      {
        key: "advanced",
        value: "상",
        text: "전치사구, 부사구, SVOC를 비롯한 모든 문장 성분을 구분하는 문제입니다. 각 문장성분의 범위는 직접 지정해야 합니다.",
      },
    ],
  },
  {
    key: "flow",
    value: "흐름정리",
  },
  {
    key: "sentence_test",
    value: "문장학습",
    options: [
      {
        key: "kor_blank",
        value: "한글 해석",
      },
      {
        key: "eng_blank",
        value: "영어 빈칸",
      },
      {
        key: "eng_blank_random",
        value: "영어 랜덤 빈칸",
      },
      {
        key: "eng_scramble",
        value: "스크램블",
      },
    ],
  },
];
